const mediaResolutions = {
  sm: '760px',
  md: '1280px',
  lg: '1600px',
};

export default mediaResolutions;
